export default class LeafletComponent{

  constructor(){
    this.init = this.init.bind(this);

    this.new_map = this.new_map.bind(this);
    this.add_marker = this.add_marker.bind(this);
    this.center_map = this.center_map.bind(this);

    this.init();
  }

  init(){
      $('.acf-map').each((idx, el) => {

          // create map
          this.new_map( $(el) );

      });
  }

  /*
  *  new_map
  *
  *  This function will render a Google Map onto the selected jQuery element
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	4.3.0
  *
  *  @param	$el (jQuery element)
  *  @return	n/a
  */
  new_map($el){
      // var
      var $markers = $el.find('.marker');

      // vars
      var args = {
        zoom		: 16,
        center		: new L.LatLng(0, 0),
        /* scrollWheelZoom: false */
        dragging: !L.Browser.mobile,
        touchZoom: true,
      };


      // create map
      var map = new L.Map( $el[0], args);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(map);


      // add a markers reference
      map.markers = [];

      // add markers
      $markers.each((idx, el) => {

          this.add_marker( $(el), map );

      });


      // center map
      this.center_map( map );


      // return
      return map;
  }

  /*
  *  add_marker
  *
  *  This function will add a marker to the selected Google Map
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	4.3.0
  *
  *  @param	$marker (jQuery element)
  *  @param	map (Google Map object)
  *  @return	n/a
  */

  add_marker( $marker, map ) {

    var markers = {
      default: 'map_marker.png',
    }

    // var
    var latlng = [$marker.attr('data-lat'), $marker.attr('data-lng') ];
    var selectedMarker = $marker.attr('data-icon') && markers[$marker.attr('data-icon')] || markers.default;

    var customIcon = L.Icon.extend({
      options: {
          iconSize:     [38, 42], // size of the icon
          shadowSize:   [30, 34], // size of the shadow
          iconAnchor:   [15, 30], // point of the icon which will correspond to marker's location
          shadowAnchor: [12, 33],  // the same for the shadow
          popupAnchor:  [0, -33], // point from which the popup should open relative to the iconAnchor
      },
    });

    // create marker
    var marker = L.marker(latlng, {
      title 		: $marker.html() || '',
      icon		: new customIcon({iconSize: [30, 33], iconUrl: '/wp-content/plugins/edu_shortcodes/assets/images/'+selectedMarker}),
    }).addTo(map);

    // add to array
    map.markers.push( marker );

    // if marker contains HTML, add it to an infoWindow
    if( $marker.html() )
    {
      // create info window
      marker.bindPopup($marker.html());
    }

  }

  /*
  *  center_map
  *
  *  This function will center the map, showing all markers attached to this map
  *
  *  @type	function
  *  @date	8/11/2013
  *  @since	4.3.0
  *
  *  @param	map (Google Map object)
  *  @return	n/a
  */

  center_map( map ) {
    // vars
    var bounds = new L.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

      var latlng = new L.LatLng( marker._latlng.lat, marker._latlng.lng );

      bounds.extend( latlng );

    });

    // only 1 marker?
    if( map.markers.length == 1 )
    {
      // set center of map
      let center = bounds.getCenter();
      map.setView(new L.LatLng(center.lat, center.lng), 16);
    }
    else
    {
      // fit to bounds
      map.fitBounds( bounds );
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/leaflet.js